import { useTranslation } from "react-i18next";
import { Dialog } from "primereact/dialog";

import PostDischargeList from "./PostDischargeList";
import { PostDischargeModalProps } from "../../../models/pages/post-discharge-modal/post-discharge-modal";
import { PostDischargeModalMode } from "../../../models/pages/post-discharge-modal/post-discharge-modal.model";
import { useState } from "react";
import UiButton from "../../../components/button/Button";
import PostDischargeCreate from "./PostDischargeCreate";
import { usePostDischarge } from "../dashboard/post-discharge/usePostDischarge";

const PostDischargeModal = (props: PostDischargeModalProps) => {
	const { t } = useTranslation("common");
	const [mode, setMode] = useState<PostDischargeModalMode>(PostDischargeModalMode.READ);

	const postDischarge = usePostDischarge(props.patientId);
	return (
		<Dialog
			header={
				<div className="dialog-custom-header">
					{/* Title */}
					<span className="dialog-custom-header__title">
						{t("PARTICIPANT.DASHBOARD.POST_DISCHARGE.MODAL.TITLE")}
					</span>

					{/* Actions */}
					{mode === PostDischargeModalMode.READ && (
						<div className="dialog-custom-header__actions">
							<UiButton
								label="PARTICIPANT.POST_DISCHARGE.CREATE"
								className="p-button-sm p-button-rounded"
								icon="pi pi-plus"
								type="button"
								onClick={() => setMode(PostDischargeModalMode.CREATE)}
							/>
						</div>
					)}
				</div>
			}
			visible={props.isVisible}
			className="post-discharge-modal"
			breakpoints={{ "960px": "80vw", "641px": "100vw" }}
			style={{ width: "80vw" }}
			modal={true}
			focusOnShow={false}
			draggable={false}
			onHide={props.closeModal}
		>
			{/* Create */}
			{mode === PostDischargeModalMode.CREATE && (
				<PostDischargeCreate
					postDischargeQuery={postDischarge}
					participantId={props.patientId}
					onCancel={() => setMode(PostDischargeModalMode.READ)}
					onComplete={() => {
						setMode(PostDischargeModalMode.READ);
						props.postDischargeInfo.invalidate();
						postDischarge.invalidate();
					}}
				/>
			)}

			{/* Read/Update */}
			{mode === PostDischargeModalMode.READ && (
				<PostDischargeList
					participantId={props.patientId}
					postDischargeQuery={postDischarge}
					postDischargeInfoQuery={props.postDischargeInfo}
				/>
			)}
		</Dialog>
	);
};

export default PostDischargeModal;
